<template>
  <dialog :open="isOpen" class="default-dialog" @click="closeModal">
    <div class="dialog-content" @click.stop>
      <header class="dialog-header">
        <div>
          <h2 class="dialog-title">{{ title }}</h2>
        </div>
        <button @click="closeModal" class="close-icon-button">✖</button>
      </header>

      <main class="dialog-body">
        <div class="quote-form">
          <div class="input-group input-group-outline m-0 d-flex flex-column">
            <label class="input-label">
              <span class="text-xs text-uppercase text-body font-weight-bolder"
                >Client ID</span
              >
              <input
                v-model="efipay.client_id"
                type="text"
                class="form-control default-bordered-input"
                placeholder="Client_Id_..."
              />
            </label>
          </div>

          <div class="input-group input-group-outline m-0 d-flex flex-column">
            <label class="input-label">
              <span class="text-xs text-uppercase text-body font-weight-bolder"
                >Client Secret</span
              >
              <input
                v-model="efipay.client_secret"
                type="text"
                class="form-control default-bordered-input"
                placeholder="Client_Secret_..."
              />
            </label>
          </div>

          <div class="input-group input-group-outline m-0 d-flex flex-column">
            <label class="input-label">
              <span class="text-xs text-uppercase text-body font-weight-bolder"
                >Chave PIX</span
              >
              <input
                v-model="efipay.pix_key"
                type="text"
                class="form-control default-bordered-input"
                placeholder="email@exemplo.com"
              />
            </label>
          </div>

          <div class="input-group input-group-outline m-0 d-flex flex-column">
            <label class="input-label">
              <span class="text-xs text-uppercase text-body font-weight-bolder"
                >Certificado P12</span
              >
              <input
                @change="handleFileUpload"
                type="file"
                accept=".p12"
                class="form-control default-bordered-input"
              />
              <span v-if="efipay.certificate" class="text-xs text-success mt-1">
                ✓ Certificado atual: {{ efipay.certificate.filename }}
              </span>
            </label>
          </div>

          <div class="switch-field">
            <label class="switch-label">
              <span class="text-xs text-uppercase text-body font-weight-bolder"
                >Repassar taxa (1,19%)</span
              >
              <InputSwitch v-model="efipay.pass_fee" />
            </label>
          </div>

          <div class="button-field">
            <button
              @click="save"
              class="btn submit-button"
              :disabled="!isFieldsFilled"
            >
              Salvar
            </button>
            <button @click="closeModal" class="btn cancel-button">
              Cancelar
            </button>
          </div>
        </div>
      </main>
    </div>
  </dialog>
</template>

<script>
import InputSwitch from "primevue/inputswitch";

export default {
  components: {
    InputSwitch,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    receivedEfipay: {
      type: Object,
      default: () => ({
        client_id: "",
        client_secret: "",
        pix_key: "",
        certificate: null,
        pass_fee: false,
      }),
    },
  },
  data() {
    return {
      title: "Configuração EFIPAY",
      efipay: {
        client_id: this.receivedEfipay?.client_id || "",
        client_secret: this.receivedEfipay?.client_secret || "",
        pix_key: this.receivedEfipay?.pix_key || "",
        certificate: this.receivedEfipay?.certificate || null,
        certificate_file: null,
        pass_fee: this.receivedEfipay?.pass_fee || false,
      },
    };
  },
  watch: {
    receivedEfipay: {
      handler(newEfipay) {
        if (newEfipay && Object.keys(newEfipay).length > 0) {
          this.efipay = {
            client_id: newEfipay?.client_id || "",
            client_secret: newEfipay?.client_secret || "",
            pix_key: newEfipay?.pix_key || "",
            certificate: newEfipay?.certificate || null,
            certificate_file: null,
            pass_fee: newEfipay?.pass_fee || false,
          };
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.efipay.certificate_file = file;
      }
    },
    save() {
      if (this.isFieldsFilled) {
        this.$emit("update:efipayForm", this.efipay);
        this.$emit("updatePayment");
        this.closeModal();
      } else {
        alert("Por favor, preencha todos os campos obrigatórios.");
      }
    },
    resetForm() {
      this.efipay = {
        client_id: "",
        client_secret: "",
        pix_key: "",
        certificate: null,
        certificate_file: null,
        pass_fee: false,
      };
    },
  },
  computed: {
    isFieldsFilled() {
      const hasBasicFields =
        this.efipay?.client_id?.trim() !== "" &&
        this.efipay?.client_secret?.trim() !== "" &&
        this.efipay?.pix_key?.trim() !== "";

      // Se já tem certificado salvo OU está fazendo upload de um novo
      const hasCertificate =
        this.efipay?.certificate || this.efipay?.certificate_file;

      return hasBasicFields && hasCertificate;
    },
  },
};
</script>

<style scoped lang="scss">
.default-dialog {
  border: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  background: none;
  backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.2);
  width: 100vw;
  height: 100vh;
}

dialog {
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s, transform 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
}

dialog[open] {
  opacity: 1;
  pointer-events: inherit;
}

dialog::backdrop {
  backdrop-filter: blur(2px);
  animation: fadein 0.2s linear;
}

.dialog-content {
  width: 600px;
  max-width: 100%;
  max-height: 90%;
  overflow: auto;
  background: white;
  border-radius: 8px;
  padding: 20px;
  z-index: 2;
  transform: scale(0.96);
  transition: transform 0.2s;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

dialog[open] .dialog-content {
  transform: scale(1);
}

.dialog-title {
  font-family: sans-serif;
  font-size: 26px;
  color: #111111;
  margin: 0;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.dialog-body {
  margin: 20px 0 0 0;
}

.close-icon-button {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
}

.button-field {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-top: 10px;
}

.cancel-button {
  background-color: #e0e0e0;
  color: #0f172a;
  display: flex;
  height: 40px;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 6px;
  line-height: 0;
  margin-bottom: 0;

  &:hover {
    background-color: #d6d6d6;
    color: #0f172a;
  }
}

.submit-button {
  background-color: #661cb0;
  color: white;
  display: flex;
  height: 40px;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 6px;
  line-height: 0;
  position: relative;
  transition: background-color 0.2s ease;
  cursor: pointer;
  margin-bottom: 0;

  &:hover {
    background-color: #7b23d3;
    color: white;
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
}

.quote-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.quote-form input {
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
}

.switch-field {
  margin: 10px 0;
}

.switch-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
</style>
